import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../../context/ProductContext';
import { formatPrice } from '../../utils/formatPrice';
import { getPrimaryImage } from '../../utils/product';

export default function AdminProducts() {
  const { products, isLoading, error, refreshProducts, deleteProduct } = useProducts();

  useEffect(() => {
    void refreshProducts({ silent: products.length > 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshProducts]);

  const handleDelete = async (id: number, name: string) => {
    if (!confirm(`"${name}" ürününü silmek istediğinize emin misiniz?`)) return;

    try {
      await deleteProduct(id);
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Ürün silinemedi.');
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Ürünler</h1>
          <p>Mağazadaki tüm ürünleri yönetin</p>
        </div>
        <Link to="/admin/products/new" className="btn btn-primary">
          + Yeni Ürün
        </Link>
      </div>

      {error && (
        <div className="auth-error">
          {error}
          <button type="button" className="btn btn-outline btn-sm" onClick={() => void refreshProducts()}>
            Tekrar Dene
          </button>
        </div>
      )}

      {isLoading ? (
        <p>Yükleniyor...</p>
      ) : products.length === 0 ? (
        <div className="admin-empty">
          <p>Henüz ürün yok.</p>
          <Link to="/admin/products/new" className="btn btn-primary">İlk Ürünü Ekle</Link>
        </div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Ürün</th>
                <th>Kategori</th>
                <th>Fiyat</th>
                <th>Stok</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.id}>
                  <td>
                    <div className="admin-product-cell">
                      <img src={getPrimaryImage(product)} alt={product.name} />
                      <div>
                        <strong>{product.name}</strong>
                        <span>{product.id}</span>
                      </div>
                    </div>
                  </td>
                  <td>{product.category}</td>
                  <td>{formatPrice(product)}</td>
                  <td>
                    <span className={`admin-badge ${product.inStock ? 'in-stock' : 'out-stock'}`}>
                      {product.stock} adet
                    </span>
                  </td>
                  <td>
                    <div className="admin-actions">
                      <Link to={`/admin/products/${product.id}/edit`} className="btn btn-outline btn-sm">
                        Düzenle
                      </Link>
                      <button
                        type="button"
                        className="btn btn-outline btn-sm admin-btn-danger"
                        onClick={() => void handleDelete(product.id, product.name)}
                      >
                        Sil
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
